// extracted by mini-css-extract-plugin
export default {"icon_img":"Tp","banner_wrapper":"Up","banner":"Vp","title_wrapper":"Wp","icons":"Xp","weekly_freq":"Yp","icon":"Zp","icon_title":"aq"};
    if(module.hot) {
      // 1713211512190
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  